import React, { useEffect, useState } from 'react';
import Calendy from './atoms/CalendlyModal';
import Message from './atoms/MessageModal';

const Techvenia = '/images/landing/techvenia-logo.svg';
const FITD = '/images/landing/FITD.svg';
const logo = '/images/landing/sv_logo_2.png';

export default function LandingFooter() {
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 650);
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    // Render the mobile version
    return (
      <>
        <div className="relative">
          <div className="bg-positionFooter" />
          <div className="bg-positionFooterO" />
          <div className="z-10">
            <div className="mx-auto max-w-7xl px-6 lg:px-8 z-10 mt-40">
              <div className="flex flex-col items-center">
                <img className="h-9 w-auto mb-3" src={logo} alt="" />
                <p className="footerText font-lato text-white-high-emphasis font-light pb-2">
                  SciVenia is an online application platform that connects organisers to scientists
                  locally and internationally. It allows for organisers to easily create events and
                  scientists to easily apply for them.
                </p>
              </div>

              <div className="">
                <dl className="pt-3">
                  <div className="flex flex-col items-center">
                    <div className="flex flex-row">
                      <div className="flex pb-4 borderBS">
                        <a href="https://www.facebook.com/techvenia" target="blank">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 mx-2"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                          </svg>
                        </a>
                        <a href="https://www.instagram.com/techvenia/" target="blank">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 mx-2"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>{' '}
                        </a>
                        <a href="https://www.linkedin.com/company/it-solutionsmk/" target="blank">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 mx-2"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                          </svg>{' '}
                        </a>
                      </div>
                    </div>
                    <dd className="mt-1 font-lato text-base font-light leading-normal underline">
                      <Calendy />
                    </dd>
                    <dd className="mt-1 font-lato text-base font-light leading-normal underline">
                      <Message />
                    </dd>
                  </div>
                </dl>

                <div className="flex justify-between gap-24 pt-5">
                  <div className="">
                    <div className="pb-3">Powered by</div>
                    <div className="bg-white p-2 rounded-3">
                      <img className="w-[141px] h-[32px] flex-shrink-0" src={Techvenia} alt="" />
                    </div>
                  </div>
                  <div className="">
                    <div className="pb-3">Supported by</div>
                    <div className="bg-white p-2 rounded-3">
                      <img className="w-[141px] h-[32px] flex-shrink-0" src={FITD} alt="" />
                    </div>
                  </div>
                </div>

                <p className="pt-5 pb-5 font-lato text-center font-light leading-normal">
                  © 2023 SciVenia. All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="relative overflow-hidden">
        <div className="bg-positionFooter" />
        <div className="bg-positionFooterO" />
        <div className="mx-auto max-w-7xl px-6 lg:px-8 z-10">
          <div className="flex flex-col items-center ">
            {/* <p className="text-white font-lato text-2xl font-normal leading-110 uppercase"> SCIVENIA </p> */}
            <img className="h-9 w-auto mt-6" src={logo} alt="" />
            <p className="footerText font-lato text-white-high-emphasis  font-light leading-6 pt-3 pb-6">
              SciVenia is an online application platform that connects organisers to scientists
              locally and internationally. <br />
              It allows for organisers to easily create events and scientists to easily apply for
              them.
            </p>
          </div>
          <div className="mx-auto grid  grid-cols-1 gap-x-8 gap-y-16  lg:grid-cols-1 pb-10">
            <dl className="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-3 lg:pt-2">
              <div className="flex flex-col justify-center sm:items-start items-center">
                <div className="pb-5">Powered by</div>
                <div className="bg-white p-2 rounded">
                  <a href="https://techvenia.com/" target="_blank" rel="noreferrer">
                    <img className="" src={Techvenia} alt="" />
                  </a>
                </div>
              </div>

              <div className="flex flex-col items-center">
                <div className="flex flex-row">
                  <div className="flex pb-5 px-5">
                    <a href="https://www.facebook.com/techvenia" target="blank">
                      {' '}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mx-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                      </svg>
                    </a>
                    <a href="https://www.instagram.com/techvenia/" target="blank">
                      {' '}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mx-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>{' '}
                    </a>
                    <a href="https://www.linkedin.com/company/it-solutionsmk/" target="blank">
                      {' '}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mx-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                      </svg>{' '}
                    </a>
                  </div>
                </div>
                <dd className="mt-2 font-lato text-base font-light leading-normal underline">
                  <Calendy />
                </dd>
                <dd className="mt-2 font-lato text-base font-light leading-normal underline">
                  <Message />
                </dd>
                <p className="pt-10 font-lato text-base font-light leading-normal">
                  © 2024 SciVenia. All rights reserved
                </p>
              </div>

              <div className="flex flex-col justify-center sm:items-end items-center">
                <div className="flex justify-center pb-5">Supported by</div>
                <div className="bg-white p-2 rounded">
                  <a href="https://fitr.mk/" target="_blank" rel="noreferrer">
                    <img className="" src={FITD} alt="FITD logo" />
                  </a>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}
